import axios from 'axios'
import store from '@/store/index.ts'
import router from '@/router'
import { setSnackbar } from 'best-modules/plugins'

function setInterceptor(/* crmRoute */) {
  axios.interceptors.request.use(
    // before request was send
    req => {
      const token = store.state.auth.token

      if (
        !req.headers['Authorization'] &&
        token &&
        (req.url.startsWith('/') || req.url.startsWith(location.origin))
      ) {
        req.headers['Authorization'] = `Bearer ${token}`
      }

      return req
    }, // request err
    err => {
      return Promise.reject(err)
    }
  )

  axios.interceptors.response.use(
    // any status in range 200 trigger res
    res => {
      if (res.data.message && !res.config.headers.DontNotify) {
        setSnackbar({ text: res.data.message || 'worked' })
      }
      return res
    }, // any status outside range 200 trigger res error
    err => {
      const initRoute = new URL(location.href).origin
      const curRoute = location.href
      const unAuthRoutes = [
        initRoute,
        `${initRoute}/`,
        `${initRoute}/authorization`,
      ]

      console.log('Request Error', err)

      if (err.response?.data?.message) {
        setSnackbar({
          text: err.response.data.message,
          color: 'error',
        })
      } else if (err.response?.data?.errors) {
        const messages = Object.values(err.response.data.errors).flat()
        setSnackbar({
          text: messages.join('\n'),
          color: 'error',
        })
      }

      if (err.response?.status === 401 && !unAuthRoutes.includes(curRoute)) {
        store.commit('removeToken')
        router.push({ name: 'login' })
      }

      const isJsonRequest = err.config?.url?.startsWith('/json')

      if (err.response?.status === 403 && isJsonRequest) {
        router.push({ name: 'home' })
      }

      return Promise.reject({ ...err, isAxios: true })
    }
  )
  return axios
}

export default setInterceptor()
